<template>
  <v-app v-if="$te('page')">
    <v-app-bar color="appshell" app flat dense prominent>
      <v-container class="d-flex flex-row align-self-center">
        <router-link class="d-flex align-center" :to="{name:'Event', params: { eventId: this.$store.state.event.event_id }}">
          <img 
           :class="this.$vuetify.breakpoint.smAndDown?undefined:'mx-4'"           
            style="margin-bottom: 0px"
            :src="require('_shared/assets/logo.svg')"
            :height="this.$vuetify.breakpoint.xs ? 44 : 62"
          />
          <!--:width="this.$vuetify.breakpoint.xs ? 293 : 408"-->
        </router-link>

        <div />
        <!-- <v-spacer /> -->
        <div class="d-flex" v-if="this.$store.getters['account/user']">
          <ToolbarUser
            class="mr-0 mr-sm-3"
            style="position: fixed; right: 0px; top: 3px"
          />
        </div>
      </v-container>
    </v-app-bar>

    <v-main>
      <ConsentView />
      <router-view />
    </v-main>

    <v-footer color="appshell">
      <FooterView :light="false" />
    </v-footer>
  </v-app>
</template>

<script>
/*eslint-disable vue/no-unused-components*/
import ToolbarUser from "_shared/account/components/ToolbarUser";
import FooterView from "_shared/Footer/FooterView.vue";

import ConsentView from "_shared/components/ConsentView";

export default {
  name: "App",
  components: {
    FooterView,
    ConsentView,
    ToolbarUser,
  },  
};
</script>

<style lang="scss">
</style>
